import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import BackgroundThumb from '../BackgroundThumb';
import s from './BackgroundThumbList.scss';
const BackgroundThumbList = (_param)=>{
    var { title, backgrounds, currentBackgroundId } = _param, thumbProps = _object_without_properties(_param, [
        "title",
        "backgrounds",
        "currentBackgroundId"
    ]);
    if (!backgrounds.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['subheader']
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: s['thumbs']
    }, backgrounds.map((bg)=>/*#__PURE__*/ React.createElement(BackgroundThumb, _object_spread({
            className: s['thumb'],
            key: bg.backgroundId,
            background: bg,
            isSelected: bg.backgroundId === currentBackgroundId
        }, thumbProps)))));
};
BackgroundThumbList.displayName = 'BackgroundThumbList';
export default BackgroundThumbList;

//# sourceMappingURL=BackgroundThumbList.js.map